import { Stack, Typography, Button } from "@mui/material";
import { MdErrorOutline } from "react-icons/md";

type Props = {
  message?: string;
  onRetry?: () => void;
};

const ErrorState = ({
  message = "حدث خطأ أثناء تحميل البيانات",
  onRetry,
}: Props) => {
  return (
    <Stack alignItems="center" justifyContent="center" gap={2} sx={{ py: 8 }}>
      <MdErrorOutline size={64} color="#D32F2F" />
      <Typography variant="h3" color="error">
        حدث خطأ
      </Typography>
      {message && (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          {message}
        </Typography>
      )}
      {onRetry && (
        <Button variant="outlined" color="primary" onClick={onRetry}>
          إعادة المحاولة
        </Button>
      )}
    </Stack>
  );
};

export default ErrorState;
